import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { TrackedPageHeader } from 'src/analytics/TrackedUI';
import { Seo } from 'src/components/Seo';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { useDevice } from 'src/hooks/useDevice';

import { ClinicPatients } from './ClinicPatients';
import { ClinicPatientsActiveFilters } from './ClinicPatientsActiveFilters';
import { useClinicPatientsFilters } from './useClinicPatientsFilters';

import styles from './ClinicPatientsPage.module.scss';

export function ClinicPatientsPage() {
  const { clinicId } = useParams();
  const intl = useIntl();
  const { toInvitePatientPage: toAddPatientPage } = useAppNavigate();
  const { isMobile } = useDevice();
  const { filters, updateFilters } = useClinicPatientsFilters(clinicId);

  if (!clinicId) {
    throw new Error('Invalid clinic');
  }

  return (
    <>
      <Seo title="Clinic Patients" />

      <div className={styles.clinicPageContainer}>
        <TrackedPageHeader
          title={intl.formatMessage({
            id: 'clinic-patients.title',
            description: 'Clinic Patients',
            defaultMessage: 'Clinic Patients',
          })}
          subtitle={
            isMobile ? (
              ''
            ) : (
              <ClinicPatientsActiveFilters
                clinicId={clinicId}
                filters={filters}
                onFilterChange={updateFilters}
              />
            )
          }
          button={{
            label: intl.formatMessage({
              id: 'invite-patient-button',
              defaultMessage: 'Add new patient',
            }),
            size: 'sm',
            onClick() {
              toAddPatientPage(clinicId);
            },
            trackLabel: 'invite-new-patient',
          }}
          extraContent={
            isMobile ? (
              <ClinicPatientsActiveFilters
                clinicId={clinicId}
                filters={filters}
                onFilterChange={updateFilters}
              />
            ) : (
              ''
            )
          }
        />
      </div>

      <ClinicPatients
        clinicId={clinicId}
        key={`ClinicActivePatients-${clinicId}`}
        filters={filters}
        onFilterChange={updateFilters}
      />
    </>
  );
}
